// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpressSetupCoverageDto } from './IExpressSetupCoverageDto';
import {
    IExpressSetupCoverageDtoFromJSON,
    IExpressSetupCoverageDtoFromJSONTyped,
    IExpressSetupCoverageDtoToJSON,
    IExpressSetupCoverageDtoToJSONTyped,
} from './IExpressSetupCoverageDto';

/**
 * 
 * @export
 * @interface IExpressSetupHealthPlanDto
 */
export interface IExpressSetupHealthPlanDto {
    /**
     * 
     * @type {number}
     * @memberof IExpressSetupHealthPlanDto
     */
    parent_id: number;
    /**
     * 
     * @type {Array<IExpressSetupCoverageDto>}
     * @memberof IExpressSetupHealthPlanDto
     */
    coverages?: Array<IExpressSetupCoverageDto>;
}

/**
 * Check if a given object implements the IExpressSetupHealthPlanDto interface.
 */
export function instanceOfIExpressSetupHealthPlanDto(value: object): value is IExpressSetupHealthPlanDto {
    if (!('parent_id' in value) || value['parent_id'] === undefined) return false;
    return true;
}

export function IExpressSetupHealthPlanDtoFromJSON(json: any): IExpressSetupHealthPlanDto {
    return IExpressSetupHealthPlanDtoFromJSONTyped(json, false);
}

export function IExpressSetupHealthPlanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupHealthPlanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'parent_id': json['parent_id'],
        'coverages': json['coverages'] == null ? undefined : ((json['coverages'] as Array<any>).map(IExpressSetupCoverageDtoFromJSON)),
    };
}

export function IExpressSetupHealthPlanDtoToJSON(json: any): IExpressSetupHealthPlanDto {
    return IExpressSetupHealthPlanDtoToJSONTyped(json, false);
}

export function IExpressSetupHealthPlanDtoToJSONTyped(value?: IExpressSetupHealthPlanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parent_id': value['parent_id'],
        'coverages': value['coverages'] == null ? undefined : ((value['coverages'] as Array<any>).map(IExpressSetupCoverageDtoToJSON)),
    };
}

